<script setup lang="ts">
import { computed } from 'vue';

import UserDropdown from "./user.vue";
import Menu from "./menu.vue";
const route = useRoute();
const router = useRouter();
const layoutStore = useLayoutStore();
const segmentStore = useSegmentStore();
const workspaceStore = useWorkspaceStore();
const workspace = computed(() => workspaceStore.currentWorkspace);

import {
    IconInbox,
    IconAt,
    IconSquareAsterisk,
    IconTelescope,
    IconUsers,
    IconGift,
    IconSettings,
    IconWorldShare,
    IconTrendingUp,
    IconMapNorth,
    IconLifebuoy,
    IconBook,
    IconLockSquare,
    IconAccessPoint,
    IconBuildings,
    IconConfetti,
    IconRefresh,
    IconProgressBolt
} from "@tabler/icons-vue";

const firstContactSegment = computed(() => {
    return segmentStore.currentContactSegment
})

const firstCompanySegment = computed(() => {
    return segmentStore.currentCompanySegment
})

const navigation = computed(() => [
   {
        name: "Onboarding",
        href: '/onboarding',
        icon: IconProgressBolt,
        current: route.path.startsWith('/onboarding'),
        show: !workspace.value?.onboarding_tasks?.is_done,
        sidebarCollapsed: false
    },
    {
        name: "Conversations",
        href: '/conversations',
        icon: IconInbox,
        current: route.path.startsWith('/conversations'),
        show: true,
        sidebarCollapsed: true
    },
    {
        name: "Contacts",
        href: `/contacts/segments/${firstContactSegment?.value?.id}`,
        icon: IconUsers,
        current: route.path.startsWith('/contacts'),
        show: true,
        sidebarCollapsed: false
    },
    {
        name: "Companies",
        href: `/companies/segments/${firstCompanySegment?.value?.id}`,
        icon: IconBuildings,
        current: route.path.startsWith('/companies'),
        show: true,
        sidebarCollapsed: false
    },
    {
        name: "Helpdesk",
        href: '/helpdesk/articles/all',
        icon: IconBook,
        current: route.path.startsWith('/helpdesk'),
        show: true,
        sidebarCollapsed: false
    },
    {
        name: "News",
        href: '/news/posts/all',
        icon: IconConfetti,
        current: route.path.startsWith('/news'),
        show: true,
        sidebarCollapsed: false
    },
    {
        name: "Settings",
        href: '/settings/personal/account',
        icon: IconSettings,
        current: route.path.startsWith('/settings'),
        show: true,
        sidebarCollapsed: false
    },
]);


const navigate = (item: any) => {
    router.push(item.href)
}
</script>

<template>
    <div class="w-52 2xl:w-56 bg-zinc-50 dark:bg-zinc-900 border-r border-zinc-100 dark:border-zinc-700 flex flex-col h-full">
        <div class="h-12 flex items-center space-x-2 border-b border-zinc-100 dark:border-zinc-700 px-4 py-1.5">
            <UserDropdown />
        </div>
        <div class="flex-1 overflow-auto">
            <div class="flex-1 flex flex-col p-2">
                <div class="space-y-2">
                    <div class="space-y-px">
                        <div v-for="item in navigation">
                            <div @click="navigate(item)" :class="[
                                item.current
                                    ? 'bg-zinc-200 dark:bg-zinc-800'
                                    : '',
                                'group flex items-center gap-x-1.5 rounded-lg py-1 px-3 text-sm font-normal cursor-pointer tracking-tight hover:bg-zinc-200 dark:hover:bg-zinc-800 text-zinc-900 dark:text-zinc-300',
                            ]">
                                <component :is="item.icon" class="size-3.5 stroke-2" aria-hidden="true" />
                                <div class="truncate">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>